<script setup lang="ts">
import { useModalManager } from "@/composables/useModalManager";
import { useAuthenticationStore } from "@/stores/useAuthenticationStore";
import { ModalEnum } from "@/types/enums";
import { computed } from "vue";
import HeartIcon from "../icons/HeartIcon.vue";
import UnLockIcon from "../icons/UnLockIcon.vue";

interface Event {
  is_free?: boolean;
}

const props = defineProps<{
  event?: Event;
  btnClass?: string;
}>();

const authStore = useAuthenticationStore();
const { setActiveModal, setRedirectUrl } = useModalManager();

const buttonText = computed(() => {
  if (authStore.user?.has_access) {
    return "Subscribed";
  }
  return props.event?.is_free ? "Get Predictions (Free)" : "Get Predictions";
});

const buttonIcon = computed(() => {
  return authStore.user?.has_access ? HeartIcon : UnLockIcon;
});

const buttonClass = computed(() => {
  return [
    props.btnClass ?? "h-[40px] px-4 bg-sky-500",
    authStore.user?.has_access
      ? "!bg-sky-100 !border !cursor-default !border-sky-500 !text-sky-500"
      : "bg-sky-500 !border-sky-500 !text-white",
  ].join(" ");
});

const buttonAction = () => {
  setRedirectUrl(window.location.pathname);
  if (!authStore.user) {
    return setActiveModal(ModalEnum.AuthModal, ModalEnum.PrePaymentModal);
  }

  if (!authStore.user.has_access) {
    return setActiveModal(ModalEnum.PrePaymentModal);
  }
};
</script>

<template>
  <Button
    @click="buttonAction"
    :class="buttonClass"
    class="flex w-full items-center justify-center gap-1 text-nowrap !rounded-md"
    :aria-label="buttonText"
    :title="buttonText"
  >
    <component :is="buttonIcon" class="h-3.5 w-3.5" />
    <div class="justify-start text-sm font-semibold">
      {{ buttonText }}
    </div>
  </Button>
</template>
